import React, { useEffect, useState } from 'react'
import CancelIcon from '@mui/icons-material/Cancel';
import ArrowDropDownCircleIcon from '@mui/icons-material/ArrowDropDownCircle';
import { notification } from '../../screens/redux/api/dummyJson';
import { msg_crm, search_icon } from '../../assets/imgs';
import moment from 'moment';
import { toast } from 'react-toastify';
import { useMmcNotificationMutation, useNotificationReplyMutation } from '../../screens/redux/api/api';
import DatePicker from 'react-datepicker';
import { Col, Pagination, Row, Spinner } from "react-bootstrap";
import ReactPaginate from 'react-paginate';
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

const MMc = () => {
    const [popup, setPopup] = useState(false);
    const [expandedNotificationId, setExpandedNotificationId] = useState(null);
    const [id, setId] = useState();
    const [reply, setReply] = useState("");
    const [loader, setLoader] = useState(false);
    const [message, setMessage] = useState(false);
    const [fromdate, setFromDate] = useState();
    const [toDate, setToDate] = useState();
    const [search, setSearch] = useState("");
    const [type, setType] = useState("");
    const [mmcList, setMmcList] = useState([]);
    const [pagecount, setPagecount] = useState(10)
    const [pageno, setPageno] = useState(1)
    const rolePermissions = JSON.parse(localStorage.getItem('permissions'))

    const [notificationReplyApi] = useNotificationReplyMutation();
    const [notificationListApi] = useMmcNotificationMutation();

    const notificationList = (pageno, fromdate, toDate, search) => {
        const formdata = new FormData();
        formdata.append("page", pageno)
        formdata.append("per_page", 10)
        if (fromdate && toDate) {
            formdata.append('start_date', moment(fromdate).format('YYYY-MM-DD'))
            formdata.append('end_date', moment(toDate).format('YYYY-MM-DD'))
        }
        if (search) {
            formdata.append('search', search)
        }
        formdata.append("row", 10)
        setFromDate(fromdate)
        setToDate(toDate)
        setSearch(search)
        setLoader(true)
        notificationListApi(formdata)
            .unwrap()
            .then((res) => {
                console.log("res", res);
                if (res?.data?.data) {
                    setMmcList(res?.data?.data)
                }

                setPagecount(res?.data?.pagination)
                setLoader(false)
            })
            .catch((err) => {
                console.log("err", err);
            }).finally(() => {
                setLoader(false);
            })

    }
    useEffect(() => {
        notificationList(pageno)
    }, [pageno])


    //    console.log("id", id)
    const notificationReply = () => {
        setPopup(true)
        const formdata = new FormData();
        formdata.append("parent_id", id)
        formdata.append("message", reply)
        setLoader(true);
        notificationReplyApi(formdata)
            .unwrap()
            .then((res) => {
                console.log("res", res);
                if (res?.status == "success") {
                    toast.success(res?.message);
                    setLoader(false)
                    setPopup(false)
                    notificationList(pageno, fromdate, toDate, search)
                    setReply("");
                }

            })
            .catch((err) => {
                console.log("err", err);
            }).finally(() => {
                setLoader(false);
            })
    }

    return (
       <div className='mt-2 position-relative w-100'>
            <div className="d-flex gap-3 ac-je filter-design">
                <label className="f2 fs-sm-8 fs-md-14 fs-lg-16 fs-xl-16 fs-xxl-18 primary ">
                    From Date
                </label>
                <div className="w-15">
                    <DatePicker
                        selected={fromdate}
                        onChange={(e) =>
                            notificationList(pageno, e, toDate, search)
                        }
                        dateFormat="dd-MM-yyyy"
                        className="input-pop-new ps-2 w-100"
                        placeholderText="From Date"
                        type="date"
                    />
                </div>
                <label className="f2 fs-sm-8 fs-md-14 fs-lg-16 fs-xl-16 fs-xxl-18 primary ">
                    To Date
                </label>
                <div className="w-15">
                    <DatePicker
                        selected={toDate}
                        onChange={(e) =>
                            notificationList(pageno, fromdate, e, search)
                        }
                        dateFormat="dd-MM-yyyy"
                        className="input-pop-new ps-2 w-100"
                        placeholderText="To Date"
                        type="date"
                    />
                </div>
                <div className="search-input">
                    <input onChange={(e) => notificationList(pageno, fromdate, toDate, e.target.value)}
                        type="text"
                        placeholder="Search"
                        style={{ border: "none", width: "150px" }}
                    />
                    <img src={search_icon} className="search" />
                </div>
            </div>
            {mmcList.map((item, index) => {
                const isExpanded = expandedNotificationId === item.id;
                const timeStr = item?.created_at?.split("T")[1]?.split(".")[0]; // Remove milliseconds
                if (!timeStr) return '';

                const [hours, minutes, seconds] = timeStr.split(":");
                const hourNum = parseInt(hours, 10);
                const ampm = hourNum >= 12 ? 'PM' : 'AM';
                const hour12 = hourNum % 12 || 12;

                return (
                    <div className='noti' key={item?.id}>
                        <p className="f2 fs-sm-7 fs-md-13 fs-lg-13 fs-xl-15 fs-xxl-17 primary">⬤ {item?.title}</p>

                        <div className='mb-4 f2 fs-sm-5 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14'>
                            {item?.message}
                        </div>

                        <div className='d-flex ac-jb'>
                            <p className="f2 fs-sm-5 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14" style={{ color: "#B36616" }}>
                                {/* {moment(item.updated_at).format("DD-MM-YYYY , hh:mm:ss A")} */}
                                {moment(item.created_at).format("DD-MM-YYYY")},  {`${hour12}:${minutes}:${seconds} ${ampm}`}
                            </p>
                            <div className='d-flex ac-jc gap-3'>
                                {item?.replies?.length == 0 && (
                                    <div>
                                        {rolePermissions?.includes('CAN-EDIT-NOTIFICATION') && (
                                            <img
                                                onClick={() => { setPopup(true); setId(item?.id) }}
                                                src={msg_crm}
                                                height='20px'
                                                width='20px'
                                                className='pointer'
                                                alt="Edit notification"
                                            />
                                        )}
                                    </div>
                                )}
                                {rolePermissions?.includes('CAN-VIEW-NOTIFICATION') && (
                                    <ArrowDropDownCircleIcon
                                        className='pointer'
                                        onClick={() => {
                                            // Toggle: if already expanded, close it; otherwise expand this one
                                            setExpandedNotificationId(isExpanded ? null : item.id);
                                        }}
                                    />
                                )}
                            </div>
                        </div>

                        {isExpanded && (
                            <div>
                                {item?.replies?.length > 0 ? (
                                    item.replies.map((reply, replyIndex) => (
                                        <div key={`reply-${item.id}-${replyIndex}`}>
                                            <p className="f2 fs-sm-7 fs-md-13 fs-lg-13 fs-xl-15 fs-xxl-17 primary">
                                                Reply By({reply?.title})
                                            </p>
                                            <p className='mb-4 f2 fs-sm-5 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14'>
                                                {reply?.message}
                                            </p>
                                        </div>
                                    ))
                                ) : (
                                    <p className="f2 fs-sm-7 fs-md-13 fs-lg-13 fs-xl-15 fs-xxl-17 primary">
                                        No Replies
                                    </p>
                                )}
                            </div>
                        )}
                    </div>
                )
            })}

            {mmcList.length == 0 && (
                <p className="f2 fs-sm-7 fs-md-13 fs-lg-13 fs-xl-15 fs-xxl-17 primary1 text-center mt-5">No Data Available</p>
            )}
            {popup && (
                <div className="img-popup-design">
                    <div className="img-popup">
                        <div className='d-flex ac-je pointer'
                            onClick={() => setPopup(false)}
                        >
                            <CancelIcon />
                        </div>
                        <h4 className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Reply Message
                        </h4>
                        <textarea type="number" value={reply} onChange={(e) => { setReply(e.target.value) }} className="input-pop ps-2 w-100" placeholder="Reply here" />

                        <div style={{ textAlign: 'center', marginTop: '30px' }}>
                            <button onClick={() => { notificationReply(id); }} className="login-btn f2 fs-sm-10 fs-md-8 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "  >
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            )}
            <Row className="justify-content-between table-show my-2 px-4 w-100">
                <Col>
                    <Pagination className="gap-1 pointer">
                        <button
                            className="page-left left-page"
                            onClick={() => {
                                setPageno(
                                    pagecount?.current_page == 1
                                        ? pagecount?.current_page
                                        : pagecount?.current_page - 1
                                );
                            }}
                        >
                            <KeyboardArrowLeftIcon className="page-left-arrow" />
                        </button>
                        <input
                            type="number"
                            className="form-control ml-2  p-1 py-1 text-center"
                            value={pagecount?.current_page}
                            onChange={(e) => {
                                setPageno(
                                    e.target.value > pagecount.last_page
                                        ? pagecount?.last_page
                                        : e.target.value
                                );
                            }}
                        />
                        <button
                            className="page-left right-page"
                            onClick={() => {
                                setPageno(
                                    pagecount?.current_page == pagecount?.last_page
                                        ? pagecount?.last_page
                                        : pagecount?.current_page + 1
                                );
                            }}
                        >
                            <KeyboardArrowRightIcon className="page-left-arrow" />
                        </button>
                    </Pagination>
                </Col>
                <Col>
                    <span className="d-flex align-items-center justify-content-end">
                        <p className="px-1 mb-0">No.Of.Pages</p>
                        <button className=" f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 form-control   text-center">
                            {pagecount?.last_page}
                        </button>
                    </span>
                </Col>
            </Row>
            {loader && (<div style={{ zIndex: 2000, position: "fixed", top: "45%", left: "49%", }}  >
                <Spinner animation="border" className="primary1" />
            </div>
            )}
        </div>
    )
}
export default MMc